module.exports = __webpack_public_path__ + "img/resized-APP-0007-2.d88ca04c.png";